import { AsyncThunk, createAsyncThunk } from "@reduxjs/toolkit";
import type { AxiosResponse } from "axios";
import { AxiosError, AxiosPromise } from "axios";

export function createAsyncThunkInstance<T = unknown>(
  actionTypeString: string,
  callback: () => Promise<T> | AxiosPromise<T> | T
): AsyncThunk<T, void, { rejectValue: AxiosError }>;
export function createAsyncThunkInstance<T = unknown, K = void>(
  actionTypeString: string,
  callback: (param: K) => Promise<T> | AxiosPromise<T> | T
): AsyncThunk<T, K, { rejectValue: AxiosError }>;
export function createAsyncThunkInstance<T = unknown>(
  actionTypeString: string,
  callback: () => Promise<AxiosResponse<T>> | AxiosResponse<T>
): AsyncThunk<T, void, { rejectValue: AxiosError }>;
export function createAsyncThunkInstance<T = unknown, K = void>(
  actionTypeString: string,
  callback: (param: K) => Promise<AxiosResponse<T>> | AxiosResponse<T>
): AsyncThunk<T, K, { rejectValue: AxiosError }>;

export function createAsyncThunkInstance(
  actionTypeString: string,
  callback: (...args: any[]) => Promise<any> | AxiosPromise<any> | any
) {
  return createAsyncThunk<any, any, { rejectValue: AxiosError }>(
    actionTypeString,
    async (param: any, { rejectWithValue }) => {
      try {
        const response = await callback(param);
        if (response && typeof response === "object" && "data" in response) {
          return (response as { data: unknown }).data;
        }
        return response;
      } catch (error: unknown) {
        console.error(error);
        throw rejectWithValue(error as AxiosError);
      }
    }
  );
}
